import React, { useEffect, useState } from "react";
import { schedulesUpdateFormStyles } from "../schedules.styles";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router-dom";
import LoadingButton from "../../shared-components/loading-button/LoadingButton";
import { toggleQuickPanel } from "app/main/shared-components/quick-panel/store";
import { addPayment } from "../store/add-payment.slice";
import { fetchReservationPayments } from "../store/payments-list.slice";
import { Column } from "app/types/TableTypes";
import BaseTable from "app/main/shared-components/base-table/BaseTable";
import { Field, Form, Formik } from "formik";
import {
  Button,
  Grid,
  MenuItem,
  Paper,
  TextField,
  Typography,
} from "@material-ui/core";
import { AppState } from "app/store";
import { ReservationType } from "app/types/service-types/ReservationTypes";
import { fetchAllPaymentMethods } from "../../configurations/store/paymentmethods/paymentmethods-list.slice";
import DateUtils from "../../../utils/DateUtils";
import { useTranslation } from "react-i18next";
import { ReservationService } from "app/services";
import { Switch, CircularProgress, Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";

const AddPayment = () => {
  const [deptAmount, setDeptAmount] = useState<any>();
  const [img, setImg] = useState(null);
  const [showImg, setShowImg] = useState("");
  const classes = schedulesUpdateFormStyles();
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const history = useHistory();
  const { params }: any = useRouteMatch();

  const reservationId = params?.id;

  const [allowMore, setAllowMore] = useState(false);
  const [loadingSwitch, setLoadingSwitch] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success" as "success" | "error" | "info",
  });

  const Alert = (props: any) => (
    <MuiAlert elevation={6} variant="filled" {...props} />
  );

  useEffect(() => {
    ReservationService.getPaymentReceiptsStatus(reservationId)
      .then((data) => {
        setAllowMore(data.canUploadMore);
        setReceipts(data.receipts || []);
      })
      .catch((err) => {
        console.error("Failed to fetch payment receipts status", err);
      });
  }, [reservationId]);

  const { reservationPayments, loading } = useSelector(
    (state: AppState) => state.schedules.reservationPayments
  );
  const { allReservations } = useSelector(
    (state: AppState) => state.schedules.schedulesList
  );
  const { allPaymentMethods } = useSelector(
    (state: AppState) => state.configurations.paymentmethods.paymentmethodsList
  );

  useEffect(() => {
    dispatch(fetchAllPaymentMethods());
  }, []);

  let selectedReservation: ReservationType | undefined;

  const [receipts, setReceipts] = useState<any[]>([]);

  useEffect(() => {
    selectedReservation = allReservations?.content.find(
      (res) => res.id === reservationId
    );
    setDeptAmount(selectedReservation?.invoice.debtAmount);

    dispatch(fetchReservationPayments(reservationId));

    // 👇 Fetch receipts here
    ReservationService.fetchPaymentReceipts(reservationId)
      .then((data) => {
        setReceipts(data);
      })
      .catch((err) => {
        console.error("Failed to load payment receipts", err);
      });
  }, []);

  useEffect(() => {
    selectedReservation = allReservations?.content.find(
      (res) => res.id === reservationId
    );
    setDeptAmount(selectedReservation?.invoice.debtAmount);
    dispatch(fetchReservationPayments(reservationId));
  }, []);

  const columns: Column[] = [
    {
      Header: `${t(
        "app.main.schedules.payments.transactionId",
        "Transaction ID"
      )}`,
      accessor: "transactionId",
    },
    {
      Header: `${t(
        "app.main.schedules.payments.paymentMethod",
        "Payment method"
      )}`,
      accessor: "method.name",
    },
    {
      Header: `${t(
        "app.main.schedules.sharedComponents.collapsibleTableRow.tableCell1",
        "Full name"
      )}`,
      accessor: "fullName",
    },
    {
      Header: `${t("app.main.schedules.payments.notes", "Notes")}`,
      accessor: "notes",
    },
    {
      Header: `${t("app.main.schedules.payments.date", "Date")}`,
      accessor: "date",
      Cell: ({ cell }: any) => {
        return DateUtils.toHumanDate(
          DateUtils.convertDate(cell.value),
          new Date(cell.value).toLocaleTimeString()
        );
      },
    },
    {
      Header: `${t("app.main.schedules.payments.type", "Type")}`,
      accessor: "type",
    },
    {
      Header: `${t("app.main.schedules.payments.amount", "Amount")}`,
      accessor: "amount",
    },
  ];

  const uploadImg = (e: any) => {
    const file = e.target.files[0];
    setImg(file);
    setShowImg(URL.createObjectURL(file));
  };

  return (
    <div className={classes.formWrapper}>
      <div className={classes.formHeader}>
        <h1 style={{ color: "#0D3B66" }}>
          {t("app.main.schedules.payments.title", "Invoice payments")}
        </h1>
      </div>
      <div>
        <BaseTable
          columns={columns}
          data={reservationPayments}
          isLoading={loading}
        />
      </div>
      <Formik
        initialValues={{
          amount: 0,
          paymentMethodId: "",
          notes: "",
        }}
        onSubmit={(data) => {
          const { amount, paymentMethodId, notes } = data;

          dispatch(
            addPayment({
              id: reservationId,
              body: {
                amount,
                paymentMethodId,
                notes,
              },
            })
          );
          dispatch(toggleQuickPanel());
          history.goBack();
        }}
      >
        {({ values }) => (
          <Form>
            <div className={classes.row}>
              <Field
                variant="outlined"
                value={values.paymentMethodId}
                name="paymentMethodId"
                label={t(
                  "app.main.schedules.payments.paymentMethod",
                  "Payment method"
                )}
                select
                as={TextField}
                required
                disabled={deptAmount === 0}
              >
                {allPaymentMethods
                  .filter((x) => x.status === true)
                  .map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
              </Field>
              <Field
                variant="outlined"
                value={values.amount}
                name="amount"
                type="number"
                //InputProps={{inputProps: {min: 1, max: deptAmount}}}
                label={t(
                  "app.main.schedules.sharedComponents.collapsibleTableRow.payment",
                  "Payment"
                )}
                as={TextField}
                required
                disabled={deptAmount === 0}
              />
            </div>
            <div className={classes.row}>
              <Field
                variant="outlined"
                value={values.notes}
                name="notes"
                type="textarea"
                multiline
                rows={3}
                label={t("app.main.schedules.payments.notes", "Notes")}
                as={TextField}
                disabled={deptAmount === 0}
              />
            </div>
            <div className={classes.row}>
              {(deptAmount > 0 || deptAmount < 0) && (
                <LoadingButton
                  type="submit"
                  btnTitle={t(
                    "app.main.schedules.update.form.submitButton",
                    "Submit"
                  )}
                  isLoading={false}
                />
              )}

              <Button
                onClick={() => {
                  dispatch(toggleQuickPanel());
                  history.goBack();
                }}
              >
                {t("app.main.schedules.splitPassenger.closeButton", "Close")}
              </Button>
            </div>
          </Form>
        )}
      </Formik>
      <div style={{ marginTop: "20px" }}>
        <Typography
          variant="h6"
          style={{ color: "#0D3B66", marginBottom: "15px" }}
        >
          {t("app.main.schedules.payments.receipts", "Payment Receipts")}
        </Typography>

        {receipts.length > 0 ? (
          <Grid container direction="column" spacing={2}>
            {receipts.map((receipt) => (
              <Grid item key={receipt.id}>
                <Paper
                  elevation={1}
                  style={{
                    padding: "12px 16px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Typography style={{ fontSize: "14px", fontWeight: 500 }}>
                    {receipt.originalFilename}
                  </Typography>

                  <Button
                    component="a"
                    href={receipt.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    color="primary"
                  >
                    {t("app.main.schedules.payments.view", "View")}
                  </Button>
                </Paper>
              </Grid>
            ))}
          </Grid>
        ) : (
          <Typography variant="body2" style={{ color: "#777" }}>
            {t(
              "app.main.schedules.payments.noReceipts",
              "No receipts uploaded yet."
            )}
          </Typography>
        )}
      </div>

      <div style={{ marginTop: "30px" }}>
        <Paper
          elevation={2}
          style={{
            padding: "16px 20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderRadius: "12px",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Typography
              variant="h6"
              style={{ color: "#0D3B66", marginBottom: "4px" }}
            >
              {t(
                "app.main.schedules.payments.allowMoreReceipts",
                "Allow More Receipts"
              )}
            </Typography>
            <Typography variant="body2" style={{ color: "#666" }}>
              {t(
                "app.main.schedules.payments.allowMoreReceiptsDesc",
                "Enable this option to allow adding additional payment receipts for this reservation."
              )}
            </Typography>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            {loadingSwitch ? (
              <CircularProgress size={24} color="primary" />
            ) : (
              <Switch
                checked={allowMore}
                onChange={async (e) => {
                  const checked = e.target.checked;
                  setAllowMore(checked);

                  try {
                    setLoadingSwitch(true);
                    if (checked) {
                      await ReservationService.allowMorePaymentReceipts(
                        reservationId
                      );
                      setSnackbar({
                        open: true,
                        message: t(
                          "app.main.schedules.payments.receiptsAllowed",
                          "More receipts allowed successfully."
                        ),
                        severity: "success",
                      });
                    } else {
                      await ReservationService.revokeAllowMorePaymentReceipts(
                        reservationId
                      );
                      setSnackbar({
                        open: true,
                        message: t(
                          "app.main.schedules.payments.receiptsRevoked",
                          "Receipts upload revoked."
                        ),
                        severity: "info",
                      });
                    }
                  } catch (err) {
                    setSnackbar({
                      open: true,
                      message: t(
                        "app.main.schedules.payments.receiptsError",
                        "Failed to update receipt settings."
                      ),
                      severity: "error",
                    });
                    // Revert switch if failed
                    setAllowMore(!checked);
                  } finally {
                    setLoadingSwitch(false);
                  }
                }}
                color="primary"
                disabled={loadingSwitch}
              />
            )}
          </div>
        </Paper>

        <Snackbar
          open={snackbar.open}
          autoHideDuration={3000}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
        >
          <Alert
            onClose={() => setSnackbar({ ...snackbar, open: false })}
            severity={snackbar.severity}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </div>
    </div>
  );
};

export default AddPayment;
